export default (id) => id.startsWith('uir');
